import React, { useCallback, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import Loading from '../components/loading';
import api from '../api/api';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import AppointmentStatus from './apointmentsStatus';
import interactionPlugin from "@fullcalendar/interaction";
import { useNavigate } from 'react-router-dom';

function Agenda() {
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);

    const [appointments, setAppointments] = useState([]);

    const getAppointmentBackground = useCallback((status) => {
        const colors = {
            scheduled: "#0dcaf0ff",
            confirmed: "#0d6efd",
            performed: "#198754",
        };
        if (status === 'SCHEDULED') {
            return colors.scheduled;
        }
        if (status === 'CONFIRMED') {
            return colors.confirmed;
        }
        if (status === 'PERFORMED') {
            return colors.performed;
        }
    }, []);

    const getAppointments = useCallback(() => {
        setLoading(true);
        api.get("/consulta", {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then((returnFromApi) => {
                const appointmentConverted = returnFromApi.data.map((appointment) => {
                    return {
                        "title": appointment.nomeDoPaciente,
                        "start": appointment.dataEHoraDeInicio,
                        "end": appointment.dataEHoraDeFim,
                        "consultaId": appointment.id,
                        "backgroundColor": getAppointmentBackground(appointment.status)
                    }
                });
                setAppointments(appointmentConverted);
                setLoading(false);
            })
            .catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }
            });
    }, [getAppointmentBackground, navigate]);

    useEffect(() => {
        getAppointments();
    }, [getAppointments]);

    const goToAppointment = (event) => {
        const appointmentId = event?.event?.extendedProps?.consultaId;

        if (appointmentId) {
            navigate('/appointment/'.concat(appointmentId));
        } else {
            const hour = String(event.date.getHours()).padStart(2, '0');
            const minute = String(event.date.getMinutes()).padStart(2, '0');
            const appointmentData = {
                hour: hour.concat(":").concat(minute),
                date: event.date
            };
            navigate('/appointment', {
                state: {
                    appointmentData: appointmentData,
                },
            });
        }
    }

    return (
        <Card className="bg-white rounded-4 shadow-lg border-0">
            <Card.Header className="bg-white border-0 py-3">
                <h5 className="mb-0 fw-bold text-muted">Agenda</h5>
            </Card.Header>

            <Loading isToHidden={isLoading === false} />

            <Card.Body>
                <AppointmentStatus />

                <div className="my-4 border-top" />

                <small className="text-muted d-block mb-3 text-center">
                   Para cadastrar uma nova consulta, clique em um dia e horário vago na agenda.
                </small>

                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
                    initialView="timeGridWeek" locale="pt-br"
                    nowIndicator={true}
                    editable={false}
                    headerToolbar={{
                        left: 'prev next today',
                        center: 'title',
                        right: 'dayGridMonth timeGridWeek timeGridDay'
                    }}
                    buttonText={{
                        month: 'Mês',
                        week: 'Semana',
                        day: 'Dia',
                        today: 'Hoje'
                    }}
                    allDayText={"Dia Inteiro"}
                    events={appointments}
                    dateClick={event => goToAppointment(event)}
                    eventClick={event => goToAppointment(event)}   
                />
            </Card.Body>
        </Card>
    );
}

export default Agenda;
